<template>
  <PreloaderComponent v-show="!isLoaded1 || !isLoaded2 || !isLoaded3" />
  <div v-show="isLoaded1 && isLoaded2 && isLoaded3">
    <h1 class="services__header">Сервисы</h1>
    <InsuranceClaimStatementListComponent
      ref="icsl"
      @contractClickHandle="nextStepDataHandle"
      @loadingIsCompleted="isLoaded1 = true; data1 = $event"
    />
    <LivingStatementListComponent
      ref="lsl"
      @contractClickHandle="nextStepDataHandle"
      @loadingIsCompleted="isLoaded2 = true; data2 = $event"
    />
    <TerminationStatementListComponent
      ref="tsl"
      @contractClickHandle="nextStepDataHandle"
      @loadingIsCompleted="isLoaded3 = true; data3 = $event"
    />
    <button
      v-show="data1.length > 0 || data2.length > 0 || data3.length > 0"
      type="button" class="services__nextStepBtn"
      :class="{services__nextStepBtn_disabled: !nextStepIsValid}"
      @click="nextStepBtnHandle()"
    >
      Далее
    </button>
  </div>
</template>

<script>
import LivingStatementListComponent from "@/profile/components/services/LivingStatetmentListComponent.vue";
import TerminationStatementListComponent
  from "@/profile/components/services/termination/TerminationStatetmentListComponent.vue";
import InsuranceClaimStatementListComponent from "@/profile/components/services/InsuranceСlaimStatementListComponent";
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";

export default {
  components: {
    TerminationStatementListComponent,
    LivingStatementListComponent,
    InsuranceClaimStatementListComponent,
    PreloaderComponent
  },
  data() {
    return {
      nextStepIsValid: true,
      nextStepData: null,
      nextStepDataType: "", // определение из какого компонента пришли данные,
      isLoaded1: false,
      data1: [],
      isLoaded2: false,
      data2: [],
      isLoaded3: false,
      data3: []
    };
  },
  methods: {
    nextStepDataHandle(contract, type) {
      this.nextStepData = contract;
      this.nextStepDataType = type;
      if (type === "icsl") { // сбросы множественного выбора
        this.$refs.tsl.chosenElement = null;
        this.$refs.lsl.chosenElement = null;
      } else if (type === "lsl") {
        this.$refs.tsl.chosenElement = null;
        this.$refs.icsl.chosenElement = null;
      } else if (type === "tsl") {
        this.$refs.lsl.chosenElement = null;
        this.$refs.icsl.chosenElement = null;
      }
    },
    nextStepBtnHandle() {
      if (this.nextStepIsValid) {
        if (this.nextStepDataType === "lsl") {
          this.$router.push({ name: "living", params: { id: this.nextStepData.id } });
        } else if (this.nextStepDataType === "tsl") {
          if (this.nextStepData.pt === "cred") {
            this.$refs.tsl.video = true;
          } else {
            this.$refs.tsl.modal_show = true;
          }
          this.$refs.tsl.selected_contract = this.nextStepData;
        } else if (this.nextStepDataType === "icsl") {
          if (this.nextStepData.insured_is_insurer !== "Y") {
            this.$refs.icsl.modal_show = true;
            return;
          }
          this.$router.push({ name: "insclaim", params: { id: Number(this.nextStepData.id) } });
        }
      }
    }
  }
};
</script>

<style scoped>

</style>